import styled from 'styled-components';
import { defaultTheme } from '../core/theme';

export const H3 = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: ${defaultTheme.colors.black};
`;
